export const AboutPage = () => {
    return (
        <>
            <div className="bg-white">
                {/* Hero / Intro Section */}
                <div className="relative isolate overflow-hidden bg-gradient-to-b from-primary/20">
                    <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                            <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-6xl mb-6">
                                Our Ethos
                            </h1>
                            <div className="text-lg leading-8 text-muted-foreground max-w-2xl">
                                <p className="mb-4">
                                    Stork Rentals started with a holiday that nearly went sideways. Travelling with a young child, we&apos;d pre-booked a car seat from a rental agency — and when we arrived late at the airport, the seat we got was the wrong size, visibly worn, and clearly not the one we&apos;d asked for. There was nothing else available.
                                </p>
                                <p className="mb-4">
                                    We made it through the trip, but we kept thinking about how many other families were having the same experience — chasing baby gear through unfamiliar airports and hoping whatever equipment was waiting for them would be safe, clean, and actually usable. So we built the service we wished had existed: premium baby equipment waiting at a Pickup location near your destination, ready to use the moment you arrive.
                                </p>
                                <p className="font-medium text-foreground">
                                    Our ethos comes from that experience. Three words sum up our business: Clean, Safe and Convenient.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Three Columns Section */}
                <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
                    <div className="mx-auto max-w-2xl lg:max-w-none">
                        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">

                            {/* Clean */}
                            <div className="flex flex-col items-start rounded-xl border border-border bg-white p-6">
                                <h3 className="font-display text-2xl tracking-tight text-foreground mb-4">Clean</h3>
                                <p className="text-base leading-7 text-muted-foreground">
                                    Every item is sanitised after each rental — strollers, car seats, cots, the lot. We inspect every surface and seam before it goes out, so what arrives at your Pickup location is properly clean and ready to use.
                                </p>
                            </div>

                            {/* Safe */}
                            <div className="flex flex-col items-start rounded-xl border border-border bg-white p-6">
                                <h3 className="font-display text-2xl tracking-tight text-foreground mb-4">Safe</h3>
                                <p className="text-base leading-7 text-muted-foreground">
                                    This is key... we are so paranoid about safety, and the weight of our responsibility weighs heavy. We check everything before it goes out - all straps, buttons, clasps, zips, isofix connectors, everything. Staff are trained and insured to install the equipment too.
                                </p>
                            </div>

                            {/* Convenience */}
                            <div className="flex flex-col items-start rounded-xl border border-border bg-white p-6">
                                <h3 className="font-display text-2xl tracking-tight text-foreground mb-4">Convenience</h3>
                                <p className="text-base leading-7 text-muted-foreground">
                                    Our service is designed to make your trip easier, you don't have to carry the gear with you in the first place; we meet you at the most convenient location for you. We install or demonstrate everything and you start your holiday!
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
